import { ActionTree } from 'vuex';
import * as types from '@webparts/store/types'
import graphApi from '@webparts/api/graph'
import { WebpartDataType } from '../types/enums';
import { IEDate, uGetDateFormat, uGetDaysInMonth } from '@appbase/util';

export default <ActionTree<webpartv3.state.WebpartsState, RootState>>{
    [types.WEBPART_COMMONDATA](action, payload: WebpartDataType[]): Promise<any> {
        action.commit(types.WEBPART_COMMONDATA_MOUNTED, false);
        let infoPromise: Promise<any>[] = [];
        let pUnreadMail = payload.indexOf(WebpartDataType.UnreadMail) >= 0;
        let pMonthlyEvent = payload.indexOf(WebpartDataType.MonthlyEvent) >= 0;

        if(pUnreadMail) {
            infoPromise.push(graphApi.getUnreadMail().then(res => {
                action.commit(types.WEBPART_UNREADMAIL_DATA, res.items);
                action.commit(types.WEBPART_UNREADMAIL_COUNT_DATA, res.count);
                return res;
            }));
        }

        if(pMonthlyEvent) {
            let today = IEDate(new Date());

            let daysList = uGetDaysInMonth(today, true, 0, true)
            let matrixStart = daysList[0]
            let matrixEnd = daysList[daysList.length - 1]

            let szStart = uGetDateFormat('yyyy-MM-dd 00:00:00', matrixStart);
            let szEnd = uGetDateFormat('yyyy-MM-dd 00:00:00', matrixEnd);

            infoPromise.push(graphApi.getCalendarEvents(szStart, szEnd).then(res => {
                action.commit(types.WEBPART_CALENDARMONTHLYEVENT_DATA, res);                        
                action.dispatch(types.WEBPART_CALENDARDAILYEVENT_DATA, { date: today });                        
                return res;
            }));
        }                             

        return Promise.all(infoPromise).then(res => {
            return res;
        }).finally(() => {
            action.commit(types.WEBPART_COMMONDATA_MOUNTED, true);            
        })
    },

    [types.WEBPART_CALENDARMONTHLYEVENT_DATA](action, payload: { start: Date, end: Date }): Promise<graph.CalendarItem[]> {
        let szStart = uGetDateFormat('yyyy-MM-dd 00:00:00', payload.start,);
        let szEnd = uGetDateFormat('yyyy-MM-dd 00:00:00', payload.end);

        return graphApi.getCalendarEvents(szStart, szEnd).then(res => {
            action.commit(types.WEBPART_CALENDARMONTHLYEVENT_DATA, res);
            return res;
        });
    },

    [types.WEBPART_CALENDARDAILYEVENT_DATA](action, payload: { date: Date }): graph.CalendarItem[] {
        let szStart: string = uGetDateFormat('yyyy-MM-dd 00:00:00', payload.date);
        let szEnd: string = uGetDateFormat('yyyy-MM-dd 23:59:59', payload.date);

        let monthlyEvents: graph.CalendarItem[] = action.state.monthlyEvents;

        let filtered = monthlyEvents.filter((e) => {
            var startTIme = IEDate(e.start.dateTime)
            var endTime = IEDate(e.end.dateTime)
            var startString = uGetDateFormat('yyyy-MM-dd H:i:s', startTIme)
            var endTimeString = uGetDateFormat('yyyy-MM-dd H:i:s', endTime)

            if(e.isAllDay) {
                return szStart >= startString && szStart <= endTimeString;
            } else {
                return (szStart <= startString && startString <= szEnd) || (szStart <= endTimeString && endTimeString <= szEnd);
            }
        })
        
        filtered.sort((a, b) => {
            if (a.isAllDay && !b.isAllDay) return -1;
            if (!a.isAllDay && b.isAllDay) return 1;

            if (!a.isAllDay && !b.isAllDay) {
                return new Date(a.start.dateTime).getTime() - new Date(b.start.dateTime).getTime();
            }
            
            return 0;
        });

        action.commit(types.WEBPART_CALENDARDAILYEVENT_DATA, filtered);
        return filtered;
    },

    [types.WEBPART_UNREADMAIL_DATA](action): Promise<graph.MailResponse> {
        return graphApi.getUnreadMail().then(res => {
            action.commit(types.WEBPART_UNREADMAIL_DATA, res.items);
            action.commit(types.WEBPART_UNREADMAIL_COUNT_DATA, res.count);
            return res;
        });
    }
}
